import React from "react";
import { Routes, Route, useLocation, Navigate, Link } from "react-router-dom";
import { Menu, Button } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import SalesUnpaid, { refreshUnpaidSales, refreshUnpaidLoading } from "./sales-unpaid";
import SalesActive, { refreshActiveSales, refreshActiveLoading } from "./sales-active";
import SalesUsed from "./sales-used";
import "./sales.css";

const Sales = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const isActiveTab = currentPath === "/sales/active";
  const refreshLoading = isActiveTab ? refreshActiveLoading : refreshUnpaidLoading;

  const items = [
    { key: "/sales", label: <Link to="/sales">Корзина</Link> },
    { key: "/sales/active", label: <Link to="/sales/active">Покупки</Link> },
    // { key: "/sales/used", label: <Link to="/sales/used">Использованные</Link> },
  ];

  const handleRefresh = () => {
    if (isActiveTab) {
      refreshActiveSales?.();
      return;
    }

    refreshUnpaidSales?.();
  };

  return (
    <div className="sales-container">
      <div className="sales-sub-menu-wrapper">
        <Menu mode="horizontal" selectedKeys={[currentPath]} items={items} className="sales-sub-menu" />
        <Button
          className="sales-refresh-button"
          icon={<ReloadOutlined />}
          onClick={handleRefresh}
          loading={refreshLoading}
          size="middle"
        >
          Обновить
        </Button>
      </div>
      <Routes>
        <Route index element={<SalesUnpaid />} />
        <Route path="active" element={<SalesActive />} />
        <Route path="used" element={<SalesUsed />} />
        <Route path="*" element={<Navigate to="/sales" replace />} />
      </Routes>
    </div>
  );
};

export default Sales;